(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-title-mega-menu]';

    const normalizeText = (value) => {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    };

    const isVisible = (element) => {
      return Boolean(
        element &&
        (
          element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length
        )
      );
    };

    const initializeMegaMenu = (root) => {
      if (root.dataset.megaMenuReady === 'true') {
        return;
      }

      const panel = root.querySelector('[data-mega-panel]');

      if (!panel) {
        return;
      }

      const triggerLabel = normalizeText(
        root.dataset.triggerLabel || 'PLATFORM'
      );

      const openOnHover =
        root.dataset.openOnHover === 'true';

      const closeDelay = Math.max(
        0,
        Number(root.dataset.closeDelay) || 250
      );

      const defaultTab =
        root.dataset.defaultTab || 'all';

      const tabButtons = Array.from(
        panel.querySelectorAll('[data-mega-tab]')
      );

      const tabPanels = Array.from(
        panel.querySelectorAll('[data-mega-tab-panel]')
      );

      const letterButtons = Array.from(
        panel.querySelectorAll('[data-mega-letter]')
      );

      let activeTab = defaultTab;
      let activeLetter = 'all';
      let activeTrigger = null;
      let closeTimer = null;
      let hideTimer = null;

      const findTriggers = () => {
        const headerCandidates = Array.from(
          document.querySelectorAll(
            [
              'header a',
              'header button',
              '.shopify-section-group-header-group a',
              '.shopify-section-group-header-group button'
            ].join(',')
          )
        );

        const candidates = headerCandidates.length
          ? headerCandidates
          : Array.from(
              document.querySelectorAll('a, button')
            );

        return candidates.filter((element) => {
          return (
            element !== panel &&
            !panel.contains(element) &&
            normalizeText(element.textContent) ===
              triggerLabel
          );
        });
      };

      const getActivePanel = () => {
        return panel.querySelector(
          `[data-mega-tab-panel="${activeTab}"]`
        );
      };

      const updateAvailableLetters = () => {
        const currentPanel = getActivePanel();

        if (!currentPanel || !letterButtons.length) {
          return;
        }

        const availableLetters = new Set(
          Array.from(
            currentPanel.querySelectorAll(
              '[data-title-item]'
            )
          ).map((item) => {
            return (
              item.dataset.firstLetter || ''
            ).toUpperCase();
          })
        );

        letterButtons.forEach((button) => {
          const letter =
            button.dataset.megaLetter || 'all';

          button.disabled =
            letter !== 'all' &&
            !availableLetters.has(letter);
        });

        const activeButton = letterButtons.find(
          (button) => {
            return (
              button.dataset.megaLetter ===
              activeLetter
            );
          }
        );

        if (activeButton?.disabled) {
          activeLetter = 'all';
        }
      };

      const applyLetterFilter = () => {
        const currentPanel = getActivePanel();

        if (!currentPanel) {
          return;
        }

        currentPanel
          .querySelectorAll('[data-title-item]')
          .forEach((item) => {
            const itemLetter = (
              item.dataset.firstLetter || ''
            ).toUpperCase();

            const shouldShow =
              activeLetter === 'all' ||
              itemLetter === activeLetter;

            item.hidden = !shouldShow;
          });

        letterButtons.forEach((button) => {
          const isActive =
            button.dataset.megaLetter ===
            activeLetter;

          button.classList.toggle(
            'is-active',
            isActive
          );

          button.setAttribute(
            'aria-pressed',
            String(isActive)
          );
        });
      };

      const selectTab = (tabName) => {
        activeTab = tabName;
        activeLetter = 'all';

        tabButtons.forEach((button) => {
          const isActive =
            button.dataset.megaTab === tabName;

          button.classList.toggle(
            'is-active',
            isActive
          );

          button.setAttribute(
            'aria-selected',
            String(isActive)
          );

          button.tabIndex = isActive ? 0 : -1;
        });

        tabPanels.forEach((tabPanel) => {
          tabPanel.hidden =
            tabPanel.dataset.megaTabPanel !==
            tabName;
        });

        updateAvailableLetters();
        applyLetterFilter();
      };

      const getHeaderBottom = (trigger) => {
        const header = trigger?.closest(
          [
            'header',
            '.shopify-section-group-header-group',
            '[data-header]'
          ].join(',')
        );

        if (header) {
          return header.getBoundingClientRect().bottom;
        }

        return trigger
          ? trigger.getBoundingClientRect().bottom
          : 80;
      };

      const positionPanel = (trigger) => {
        panel.hidden = false;

        const viewportPadding = 12;
        const panelWidth =
          panel.getBoundingClientRect().width;

        const triggerRect = trigger
          ? trigger.getBoundingClientRect()
          : null;

        let left = triggerRect
          ? triggerRect.left
          : (window.innerWidth - panelWidth) / 2;

        left = Math.max(
          viewportPadding,
          Math.min(
            left,
            window.innerWidth -
              panelWidth -
              viewportPadding
          )
        );

        const top = Math.max(
          viewportPadding,
          getHeaderBottom(trigger)
        );

        panel.style.left = `${left}px`;
        panel.style.top = `${top}px`;
      };

      const cancelClose = () => {
        window.clearTimeout(closeTimer);
        window.clearTimeout(hideTimer);
      };

      const setTriggerState = (expanded) => {
        findTriggers().forEach((trigger) => {
          trigger.setAttribute(
            'aria-expanded',
            String(
              expanded &&
              trigger === activeTrigger
            )
          );

          trigger.setAttribute(
            'aria-controls',
            panel.id
          );

          trigger.setAttribute(
            'aria-haspopup',
            'true'
          );
        });
      };

      const openMenu = (trigger) => {
        cancelClose();

        activeTrigger =
          trigger ||
          findTriggers().find(isVisible) ||
          null;

        positionPanel(activeTrigger);

        panel.setAttribute('aria-hidden', 'false');

        setTriggerState(true);

        window.requestAnimationFrame(() => {
          panel.classList.add('is-open');
        });
      };

      const closeMenu = (immediate = false) => {
        cancelClose();

        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');

        setTriggerState(false);

        const finishClose = () => {
          if (!panel.classList.contains('is-open')) {
            panel.hidden = true;
          }

          activeTrigger = null;
        };

        if (immediate) {
          finishClose();
        } else {
          hideTimer = window.setTimeout(
            finishClose,
            190
          );
        }
      };

      const scheduleClose = () => {
        cancelClose();

        closeTimer = window.setTimeout(() => {
          closeMenu();
        }, closeDelay);
      };

      const toggleMenu = (trigger) => {
        if (panel.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu(trigger);
        }
      };

      const bindTriggers = () => {
        findTriggers().forEach((trigger) => {
          if (
            trigger.dataset.titleMegaMenuBound ===
            root.id
          ) {
            return;
          }

          trigger.dataset.titleMegaMenuBound =
            root.id;

          trigger.setAttribute(
            'aria-controls',
            panel.id
          );

          trigger.setAttribute(
            'aria-haspopup',
            'true'
          );

          trigger.setAttribute(
            'aria-expanded',
            'false'
          );

          if (openOnHover) {
            trigger.addEventListener(
              'pointerenter',
              (event) => {
                if (
                  event.pointerType === 'mouse' ||
                  event.pointerType === 'pen'
                ) {
                  openMenu(trigger);
                }
              }
            );

            trigger.addEventListener(
              'pointerleave',
              scheduleClose
            );
          }

          trigger.addEventListener(
            'focus',
            () => {
              openMenu(trigger);
            }
          );

          trigger.addEventListener(
            'click',
            (event) => {
              const desktopHoverAvailable =
                window.matchMedia(
                  '(hover: hover) and (pointer: fine)'
                ).matches;

              if (
                !openOnHover ||
                !desktopHoverAvailable
              ) {
                event.preventDefault();
                toggleMenu(trigger);
              }
            }
          );
        });
      };

      tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectTab(button.dataset.megaTab);
        });

        button.addEventListener(
          'keydown',
          (event) => {
            if (
              event.key !== 'ArrowLeft' &&
              event.key !== 'ArrowRight'
            ) {
              return;
            }

            event.preventDefault();

            const currentIndex =
              tabButtons.indexOf(button);

            const direction =
              event.key === 'ArrowRight'
                ? 1
                : -1;

            const nextIndex =
              (
                currentIndex +
                direction +
                tabButtons.length
              ) % tabButtons.length;

            const nextButton =
              tabButtons[nextIndex];

            selectTab(nextButton.dataset.megaTab);
            nextButton.focus();
          }
        );
      });

      letterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) {
            return;
          }

          activeLetter =
            button.dataset.megaLetter || 'all';

          applyLetterFilter();
        });
      });

      panel.addEventListener(
        'pointerenter',
        cancelClose
      );

      panel.addEventListener(
        'pointerleave',
        scheduleClose
      );

      panel.addEventListener(
        'focusin',
        cancelClose
      );

      panel.addEventListener(
        'focusout',
        (event) => {
          const nextElement = event.relatedTarget;

          if (
            !panel.contains(nextElement) &&
            !findTriggers().includes(nextElement)
          ) {
            scheduleClose();
          }
        }
      );

      document.addEventListener('click', (event) => {
        if (
          panel.contains(event.target) ||
          findTriggers().some((trigger) => {
            return trigger.contains(event.target);
          })
        ) {
          return;
        }

        closeMenu();
      });

      document.addEventListener(
        'keydown',
        (event) => {
          if (
            event.key === 'Escape' &&
            panel.classList.contains('is-open')
          ) {
            closeMenu();

            if (activeTrigger) {
              activeTrigger.focus();
            }
          }
        }
      );

      window.addEventListener(
        'resize',
        () => {
          if (panel.classList.contains('is-open')) {
            positionPanel(activeTrigger);
          }
        }
      );

      window.addEventListener(
        'scroll',
        () => {
          if (panel.classList.contains('is-open')) {
            positionPanel(activeTrigger);
          }
        },
        { passive: true }
      );

      selectTab(defaultTab);
      bindTriggers();

      root.dataset.megaMenuReady = 'true';

      if (
        window.Shopify &&
        Shopify.designMode
      ) {
        document.addEventListener(
          'shopify:section:select',
          (event) => {
            if (
              event.detail.sectionId ===
              root.closest('.shopify-section')?.id
                ?.replace('shopify-section-', '')
            ) {
              openMenu(
                findTriggers().find(isVisible)
              );
            }
          }
        );
      }
    };

    const initializeAllMegaMenus = (
      scope = document
    ) => {
      scope
        .querySelectorAll(ROOT_SELECTOR)
        .forEach(initializeMegaMenu);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initializeAllMegaMenus(document);
        }
      );
    } else {
      initializeAllMegaMenus(document);
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAllMegaMenus(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-up-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-three-up-slider]';

    const initializeSlider = (root) => {
      if (root.dataset.sliderReady === 'true') {
        return;
      }

      const viewport = root.querySelector(
        '[data-slider-viewport]'
      );

      const track = root.querySelector(
        '[data-slider-track]'
      );

      const scrollbar = root.querySelector(
        '[data-slider-scrollbar]'
      );

      const thumb = root.querySelector(
        '[data-slider-thumb]'
      );

      const previousButton = root.querySelector(
        '[data-slider-previous]'
      );

      const nextButton = root.querySelector(
        '[data-slider-next]'
      );

      if (!viewport || !track || !scrollbar || !thumb) {
        return;
      }

      const realSlides = Array.from(
        track.children
      ).filter((slide) => {
        return (
          slide.matches('[data-three-up-slide]') &&
          !slide.hasAttribute('data-loop-clone')
        );
      });

      if (!realSlides.length) {
        return;
      }

      const realSlideCount = realSlides.length;
      const cloneCount = Math.min(3, realSlideCount);

      let slideStep = 0;
      let loopStart = 0;
      let loopWidth = 0;
      let currentIndex = 0;

      let updateFrame = null;
      let scrollEndTimer = null;
      let autoplayTimer = null;

      let mouseDrag = null;
      let thumbDrag = null;
      let suppressNextClick = false;

      const modulo = (number, divisor) => {
        return ((number % divisor) + divisor) % divisor;
      };

      const prepareClone = (slide) => {
        const clone = slide.cloneNode(true);

        clone.setAttribute('data-loop-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');

        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');

        clone
          .querySelectorAll('[id]')
          .forEach((element) => {
            element.removeAttribute('id');
          });

        clone
          .querySelectorAll('[data-shopify-editor-block]')
          .forEach((element) => {
            element.removeAttribute(
              'data-shopify-editor-block'
            );
          });

        clone
          .querySelectorAll(
            'a, button, input, select, textarea, [tabindex]'
          )
          .forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });

        return clone;
      };

      const createLoopClones = () => {
        if (realSlideCount <= 1) {
          return;
        }

        const beforeFragment =
          document.createDocumentFragment();

        const afterFragment =
          document.createDocumentFragment();

        realSlides
          .slice(-cloneCount)
          .forEach((slide) => {
            beforeFragment.appendChild(
              prepareClone(slide)
            );
          });

        realSlides
          .slice(0, cloneCount)
          .forEach((slide) => {
            afterFragment.appendChild(
              prepareClone(slide)
            );
          });

        track.insertBefore(
          beforeFragment,
          track.firstChild
        );

        track.appendChild(afterFragment);
      };

      const getGap = () => {
        const styles = window.getComputedStyle(track);

        return (
          parseFloat(
            styles.columnGap ||
            styles.gap ||
            '0'
          ) || 0
        );
      };

      const measureSlider = () => {
        const firstSlide = track.querySelector(
          '[data-three-up-slide]'
        );

        if (!firstSlide) {
          return;
        }

        slideStep =
          firstSlide.getBoundingClientRect().width +
          getGap();

        loopStart = cloneCount * slideStep;
        loopWidth = realSlideCount * slideStep;
      };

      const setScrollInstantly = (position) => {
        const previousBehavior =
          viewport.style.scrollBehavior;

        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = position;

        viewport.getBoundingClientRect();

        viewport.style.scrollBehavior =
          previousBehavior;
      };

      const getVisibleSlideCount = () => {
        if (!slideStep) {
          return 1;
        }

        return viewport.clientWidth / slideStep;
      };

      const hasHiddenSlides = () => {
        return (
          realSlideCount >
          getVisibleSlideCount() + 0.05
        );
      };

      const getLogicalIndex = () => {
        if (!slideStep || !realSlideCount) {
          return 0;
        }

        const rawIndex = Math.round(
          (viewport.scrollLeft - loopStart) /
          slideStep
        );

        return modulo(rawIndex, realSlideCount);
      };

      const normalizeLoopPosition = () => {
        if (
          realSlideCount <= 1 ||
          !slideStep ||
          !loopWidth
        ) {
          return;
        }

        const relativePosition =
          viewport.scrollLeft - loopStart;

        const outsideRealSlides =
          relativePosition < -1 ||
          relativePosition >= loopWidth - 1;

        if (outsideRealSlides) {
          const normalizedPosition = modulo(
            relativePosition,
            loopWidth
          );

          setScrollInstantly(
            loopStart + normalizedPosition
          );
        }

        currentIndex = getLogicalIndex();
        scheduleInterfaceUpdate();
      };

      const updateInterface = () => {
        updateFrame = null;

        measureSlider();

        currentIndex = getLogicalIndex();

        const sliderHasMore = hasHiddenSlides();
        const scrollbarWidth =
          scrollbar.clientWidth;

        if (
          realSlideCount <= 1 ||
          !sliderHasMore ||
          scrollbarWidth <= 0
        ) {
          scrollbar.hidden = true;

          if (previousButton) {
            previousButton.disabled = true;
          }

          if (nextButton) {
            nextButton.disabled = true;
          }

          thumb.setAttribute('aria-valuenow', '0');
          return;
        }

        scrollbar.hidden = false;

        if (previousButton) {
          previousButton.disabled = false;
        }

        if (nextButton) {
          nextButton.disabled = false;
        }

        const visibleRatio = Math.min(
          1,
          getVisibleSlideCount() /
          realSlideCount
        );

        const minimumThumbWidth = Math.min(
          48,
          scrollbarWidth
        );

        const calculatedThumbWidth = Math.max(
          minimumThumbWidth,
          scrollbarWidth * visibleRatio
        );

        const thumbWidth = Math.min(
          scrollbarWidth,
          calculatedThumbWidth
        );

        thumb.style.width = `${thumbWidth}px`;

        const availableTravel = Math.max(
          0,
          scrollbarWidth - thumbWidth
        );

        const progress =
          realSlideCount > 1
            ? currentIndex /
              (realSlideCount - 1)
            : 0;

        thumb.style.transform =
          `translate3d(${availableTravel * progress}px, 0, 0)`;

        thumb.setAttribute(
          'aria-valuenow',
          String(Math.round(progress * 100))
        );
      };

      const scheduleInterfaceUpdate = () => {
        if (updateFrame !== null) {
          return;
        }

        updateFrame = window.requestAnimationFrame(
          updateInterface
        );
      };

      const scheduleLoopNormalization = () => {
        window.clearTimeout(scrollEndTimer);

        scrollEndTimer = window.setTimeout(() => {
          if (!mouseDrag && !thumbDrag) {
            normalizeLoopPosition();
          }
        }, 140);
      };

      const scrollToPosition = (
        position,
        behavior = 'smooth'
      ) => {
        viewport.scrollTo({
          left: position,
          behavior
        });
      };

      const scrollByOneSlide = (direction) => {
        measureSlider();

        scrollToPosition(
          viewport.scrollLeft +
          slideStep * direction
        );
      };

      const scrollToLogicalIndex = (index) => {
        measureSlider();

        const normalizedIndex = modulo(
          index,
          realSlideCount
        );

        scrollToPosition(
          loopStart +
          normalizedIndex * slideStep
        );
      };

      const snapToClosestSlide = () => {
        if (!slideStep) {
          return;
        }

        const targetPosition =
          Math.round(
            viewport.scrollLeft / slideStep
          ) * slideStep;

        scrollToPosition(targetPosition);
      };

      const stopAutoplay = () => {
        if (autoplayTimer !== null) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();

        const autoplayEnabled =
          root.dataset.autoplay === 'true';

        const reduceMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        measureSlider();

        if (
          !autoplayEnabled ||
          reduceMotion ||
          document.hidden ||
          !hasHiddenSlides()
        ) {
          return;
        }

        const delay = Math.max(
          2000,
          Number(root.dataset.autoplaySpeed) ||
          5000
        );

        autoplayTimer = window.setInterval(() => {
          /*
           * 마지막 실제 배너 이후에는
           * 첫 번째 복제 배너로 계속 전진한다.
           *
           * 이동이 끝난 뒤 normalizeLoopPosition이
           * 같은 위치의 실제 첫 배너로 바꾼다.
           */
          scrollByOneSlide(1);
        }, delay);
      };

      createLoopClones();

      viewport.addEventListener(
        'scroll',
        () => {
          scheduleInterfaceUpdate();
          scheduleLoopNormalization();
        },
        { passive: true }
      );

      viewport.addEventListener(
        'dragstart',
        (event) => {
          event.preventDefault();
        }
      );

      viewport.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            stopAutoplay();
            scrollByOneSlide(-1);
            startAutoplay();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            stopAutoplay();
            scrollByOneSlide(1);
            startAutoplay();
          }

          if (event.key === 'Home') {
            event.preventDefault();
            stopAutoplay();
            scrollToLogicalIndex(0);
            startAutoplay();
          }

          if (event.key === 'End') {
            event.preventDefault();
            stopAutoplay();
            scrollToLogicalIndex(
              realSlideCount - 1
            );
            startAutoplay();
          }
        }
      );

      /*
       * 마우스 드래그
       * 모바일은 브라우저 기본 스와이프 사용
       */

      viewport.addEventListener(
        'pointerdown',
        (event) => {
          if (
            event.pointerType !== 'mouse' ||
            event.button !== 0
          ) {
            return;
          }

          if (
            event.target.closest(
              'button, input, select, textarea'
            )
          ) {
            return;
          }

          stopAutoplay();

          mouseDrag = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startScrollLeft: viewport.scrollLeft,
            moved: false
          };

          viewport.classList.add('is-dragging');

          if (viewport.setPointerCapture) {
            viewport.setPointerCapture(
              event.pointerId
            );
          }
        }
      );

      viewport.addEventListener(
        'pointermove',
        (event) => {
          if (
            !mouseDrag ||
            mouseDrag.pointerId !==
              event.pointerId
          ) {
            return;
          }

          const distance =
            event.clientX - mouseDrag.startX;

          if (Math.abs(distance) > 4) {
            mouseDrag.moved = true;
          }

          if (mouseDrag.moved) {
            event.preventDefault();

            viewport.scrollLeft =
              mouseDrag.startScrollLeft -
              distance;
          }
        }
      );

      const endMouseDrag = (event) => {
        if (
          !mouseDrag ||
          mouseDrag.pointerId !==
            event.pointerId
        ) {
          return;
        }

        const moved = mouseDrag.moved;

        mouseDrag = null;

        viewport.classList.remove(
          'is-dragging'
        );

        if (
          viewport.hasPointerCapture &&
          viewport.hasPointerCapture(
            event.pointerId
          )
        ) {
          viewport.releasePointerCapture(
            event.pointerId
          );
        }

        if (moved) {
          suppressNextClick = true;
          snapToClosestSlide();

          window.setTimeout(() => {
            suppressNextClick = false;
          }, 150);
        }

        startAutoplay();
      };

      viewport.addEventListener(
        'pointerup',
        endMouseDrag
      );

      viewport.addEventListener(
        'pointercancel',
        endMouseDrag
      );

      viewport.addEventListener(
        'lostpointercapture',
        () => {
          mouseDrag = null;

          viewport.classList.remove(
            'is-dragging'
          );

          startAutoplay();
        }
      );

      viewport.addEventListener(
        'click',
        (event) => {
          if (!suppressNextClick) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      if (previousButton) {
        previousButton.addEventListener(
          'click',
          () => {
            stopAutoplay();
            scrollByOneSlide(-1);
            startAutoplay();
          }
        );
      }

      if (nextButton) {
        nextButton.addEventListener(
          'click',
          () => {
            stopAutoplay();
            scrollByOneSlide(1);
            startAutoplay();
          }
        );
      }

      /*
       * 커스텀 스크롤바 클릭
       */

      scrollbar.addEventListener(
        'pointerdown',
        (event) => {
          if (event.target === thumb) {
            return;
          }

          stopAutoplay();

          const bounds =
            scrollbar.getBoundingClientRect();

          const thumbWidth =
            thumb.getBoundingClientRect().width;

          const availableTravel = Math.max(
            1,
            bounds.width - thumbWidth
          );

          const clickPosition =
            event.clientX -
            bounds.left -
            thumbWidth / 2;

          const progress = Math.max(
            0,
            Math.min(
              1,
              clickPosition /
              availableTravel
            )
          );

          const targetIndex = Math.round(
            progress *
            (realSlideCount - 1)
          );

          scrollToLogicalIndex(targetIndex);
          startAutoplay();
        }
      );

      /*
       * 커스텀 스크롤바 드래그
       */

      thumb.addEventListener(
        'pointerdown',
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          stopAutoplay();

          thumbDrag = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startIndex: currentIndex
          };

          thumb.classList.add('is-dragging');

          if (thumb.setPointerCapture) {
            thumb.setPointerCapture(
              event.pointerId
            );
          }
        }
      );

      thumb.addEventListener(
        'pointermove',
        (event) => {
          if (
            !thumbDrag ||
            thumbDrag.pointerId !==
              event.pointerId
          ) {
            return;
          }

          const scrollbarWidth =
            scrollbar.clientWidth;

          const thumbWidth =
            thumb.getBoundingClientRect().width;

          const availableTravel = Math.max(
            1,
            scrollbarWidth - thumbWidth
          );

          const distance =
            event.clientX -
            thumbDrag.startX;

          const indexChange = Math.round(
            (
              distance /
              availableTravel
            ) *
            (realSlideCount - 1)
          );

          const targetIndex = Math.max(
            0,
            Math.min(
              realSlideCount - 1,
              thumbDrag.startIndex +
              indexChange
            )
          );

          setScrollInstantly(
            loopStart +
            targetIndex * slideStep
          );

          currentIndex = targetIndex;
          scheduleInterfaceUpdate();
        }
      );

      const endThumbDrag = (event) => {
        if (
          !thumbDrag ||
          thumbDrag.pointerId !==
            event.pointerId
        ) {
          return;
        }

        thumbDrag = null;

        thumb.classList.remove(
          'is-dragging'
        );

        if (
          thumb.hasPointerCapture &&
          thumb.hasPointerCapture(
            event.pointerId
          )
        ) {
          thumb.releasePointerCapture(
            event.pointerId
          );
        }

        snapToClosestSlide();
        startAutoplay();
      };

      thumb.addEventListener(
        'pointerup',
        endThumbDrag
      );

      thumb.addEventListener(
        'pointercancel',
        endThumbDrag
      );

      thumb.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            scrollByOneSlide(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            scrollByOneSlide(1);
          }

          if (event.key === 'Home') {
            event.preventDefault();
            scrollToLogicalIndex(0);
          }

          if (event.key === 'End') {
            event.preventDefault();
            scrollToLogicalIndex(
              realSlideCount - 1
            );
          }
        }
      );

      root.addEventListener(
        'pointerenter',
        stopAutoplay
      );

      root.addEventListener(
        'pointerleave',
        startAutoplay
      );

      root.addEventListener(
        'focusin',
        stopAutoplay
      );

      root.addEventListener(
        'focusout',
        startAutoplay
      );

      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        }
      );

      const repositionAfterResize = () => {
        measureSlider();

        setScrollInstantly(
          loopStart +
          currentIndex * slideStep
        );

        scheduleInterfaceUpdate();
      };

      if ('ResizeObserver' in window) {
        const resizeObserver =
          new ResizeObserver(() => {
            repositionAfterResize();
          });

        resizeObserver.observe(viewport);
        resizeObserver.observe(track);
      } else {
        window.addEventListener(
          'resize',
          repositionAfterResize
        );
      }

      root.dataset.sliderReady = 'true';

      window.requestAnimationFrame(() => {
        measureSlider();

        /*
         * 앞쪽에 복제한 마지막 배너들을 건너뛰고
         * 첫 번째 실제 배너에서 시작한다.
         */
        setScrollInstantly(loopStart);

        currentIndex = 0;

        scheduleInterfaceUpdate();
        startAutoplay();
      });
    };

    const initializeAllSliders = (
      scope = document
    ) => {
      scope
        .querySelectorAll(ROOT_SELECTOR)
        .forEach(initializeSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initializeAllSliders(document);
        }
      );
    } else {
      initializeAllSliders(document);
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAllSliders(event.target);
      }
    );

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const selectedSlide =
          event.target.closest(
            '[data-three-up-slide]:not([data-loop-clone])'
          );

        if (!selectedSlide) {
          return;
        }

        selectedSlide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
